import {
    GET_LINK_PAYMENT_STATUS_DEF_SUCCESS,
    LINK_PAYMENT_STATUS_DEF_API_ERROR
} from "./actionTypes"

const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
}

const linkPaymentStatusDef = (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_LINK_PAYMENT_STATUS_DEF_SUCCESS:
            return {
                ...state,
                recordList: action.payload,
            }

        case LINK_PAYMENT_STATUS_DEF_API_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default linkPaymentStatusDef